import { render, staticRenderFns } from "./AdviceNoteModal.vue?vue&type=template&id=442f7deb"
import script from "./AdviceNoteModal.vue?vue&type=script&lang=js"
export * from "./AdviceNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports